import DashedLine from "features/CenterContent/VehicleDetails/shared/DashedLine";
import { Link, To } from "react-router-dom";
import { Flex, FlexProps } from "shared/components/Spor";
import { VariantColor } from "shared/utils/colorUtils";
import { FCWC } from "shared/utils/FCWC";
import { useTheme } from "styled-components";

type ElementProps = {
  isHover?: boolean;
  selected: boolean;
  dashedColor?: VariantColor;
  to?: To;
  linkState?: { [key: string]: unknown };
  hideDashedLine?: boolean;
} & FlexProps;

const ElementWrapper: FCWC<ElementProps> = ({
  to,
  linkState,
  isHover,
  children,
  selected,
  dashedColor = "secondary",
  backgroundColor,
  hideDashedLine,
  ...props
}) => {
  const theme = useTheme();

  const element = (
    <Flex
      as="li"
      gap="1"
      justifyContent="space-between"
      alignItems="center"
      alignContent="center"
      p="2"
      borderRadius="6px"
      backgroundColor={
        selected
          ? theme.colorSelected
          : (backgroundColor ?? theme.colorBackgroundSecondary)
      }
      _hover={
        isHover
          ? {
              filter: theme.filterHover,
              cursor: "pointer",
            }
          : undefined
      }
      {...props}
    >
      {children}
    </Flex>
  );

  return (
    <>
      {to ? (
        <Link to={to} state={linkState}>
          {element}
        </Link>
      ) : (
        element
      )}
      {!hideDashedLine && <DashedLine variant={dashedColor} />}
    </>
  );
};

export default ElementWrapper;
